<template>
  <div class="FMS-main">
    <div class="top-container"></div>
    <div class="bottom-container">
      <GanttChart />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import GanttChart from '@/components/charts/GanttChart.vue';

export default {
  components: {
    GanttChart
  },
  props: {
  },
  methods: {
  },
  mounted() {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.FMS-main {
  padding: 5px 45px;
  font-size: 12px;

  > .top-container {
    width: 100%;
    height: 150px;
    background-color: white;
    border-radius: 5px;
  }

  > .bottom-container {
    margin-top: 5px;
    height: calc(100% - 155px);
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 5px;
  }
}
</style>